import React from "react";
import { DeleteGrayIcon } from "../tabsvgs";

export const CardView = ({ icon, title, summaryData }) => {
  return (
    <div className="w-[100%] h-[180px] flex flex-col items-start justify-start p-4 bg-white rounded-[15px] shadow-md border-t-2 border-[#1d2951]">
      <div className="flex items-center mb-2 mx-1.5">
        <img src={icon} alt={`${title} Icon`} className="mr-2" />
        <span className="text-sm text-[#1d2951] font-semibold uppercase">{title}</span>
      </div>
   \
      <div
        className="w-full flex justify-center overflow-y-auto scrollbar-hidden align-center"
        style={{ scrollbarWidth: "none" }}
      >
        <ul className="w-[80%] space-y-2 ">
          {summaryData &&
            summaryData.map((item) => (
              <div>
                <li className="flex justify-between items-center">
                  <span className="w-full relative text-sm leading-6 font-light text-[#16151c] text-left inline-block font-inter">
                  {item.ordername && item.ordername.trim() !== '' 
  ? item.ordername 
  : `${item.tov} - Level ${item.lov}`}

                  </span>
                  <div
                    className={`w-3 h-3 rounded-full ${
                      item.status === "COMPLETED"
                        ? "bg-[#649F70]"
                        : item.status === "INFO"
                        ? "bg-blue-500"
                        : item.status === "CREATED"
                        ? "bg-[#E17954]"
                        : "bg-gray-400"
                    }`}
                  ></div>
                </li>
                <hr className="border-gray-300 w-full" />
              </div>
            ))}
          {summaryData?.length === 0 && <p>No orders found.</p>}
        </ul>
      </div>
    </div>
  );
};
